import React from "react";
import { Modal, Button } from "antd";
import TableSchema, { type DataType, TableApi } from "../controllers/TableSchema";
import { Form, Input, message } from "antd";
import Axios from "axios";
import { AxiosResponse, AxiosError } from "axios";
import { Message } from "./Messages"

type Props = {
  onClose: () => void,
  tableSchema: TableSchema,
  form?: any
};

type State = {
  visible: boolean,
  ModalText: string,
  confirmLoading: boolean,
  formItems: Array<Object>
};
function defaultState(): State {
  return {
    visible: true,
    ModalText: "Content of the modal",
    confirmLoading: false,
    formItems: []
  };
}

class InsertTableRow extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = defaultState();
  }

  componentDidMount() {}

  createFormItem(key: string, label: string, type: DataType) {
  //  const value = this.props.record[key];
    return this.createTextInput(key, label, type);
  }

  getFieldDecorator(key: string, params: Object = {}) {
    return this.props.form
      ? this.props.form.getFieldDecorator(key, params)
      : (a: any) => console.log(arguments);
  }

  createTextInput(key: string, label: string, value: any, type: DataType) {
    const v = type === "number" ? parseInt(value) : value;
    return (
      <Form.Item
        label={label.toUpperCase()}
        key={key}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
      >
        {this.getFieldDecorator(key, {
         // initialValue: v
        })(
          <Input
            placeholder={label.toUpperCase()}
            name={key}
            disabled={type === "date"}
            type={type !== "number" ? "string" : "number"}
          />
        )}
      </Form.Item>
    );
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleOk = () => {
    this.saveForm();
    this.setState({
      confirmLoading: true
    });
  };

  handleCancel = () => {
    this.close();
  };

  saveForm = () => {
    const { form } = this.props;
    if (form) {
      form.validateFields((err, values) => {
        if (err) {
          alert(err);
          return;
        }
        // Send a POST request
        Axios({
          method: "post",
          withCredentials: false,
          headers: { "Access-Control-Allow-Origin": "localhost" },
          url: TableApi.POST_ACTION + this.props.tableSchema.getTableKey() + "/" +this.props.actionKey ,
          data: values
        })
          .then(response => {
            this.handleSaveResponse(response);
          })
          .catch(error => {
            console.log(error);
            this.handleError(error);
          });
      });
    } else {
      alert(Message.FORM_NOT_DEFINE);
    }
  };

  handleError(error: AxiosError) {
    alert(error.response.data);
    this.setState({ confirmLoading: false });
  }

  handleSaveResponse = (response: AxiosResponse) => {
    if (response.status === 200) {
      message.success(this.props.actionKey[0].toUpperCase() + this.props.actionKey.slice(1) + " " + Message.SUCCESSFULLY);
      this.props.fetchAllData();
      this.close();
    }
  };

  close() {
    this.setState({ visible: false, confirmLoading: false }, this.props.onClose);
  }

  render() {
    const { visible, confirmLoading } = this.state;
    const tableSchema: TableSchema = this.props.tableSchema;
    const formItems: Array<Object> = [];
    if (tableSchema) {
      const count = tableSchema.getColumnnsCount();
      for (let index = 0; index < count; index++) {
        const key = tableSchema.getColumnKey(index);
        const label = tableSchema.getColumnLabel(index);
        const type: DataType = tableSchema.getColumnType(index);
        const formItem = this.createFormItem(key, label, type);
        formItems.push(formItem);
      }
    //   const key = this.props.record["key"];
    //   if (key != null) {
    //     const formItem = this.createFormItem("key", "Key", "string");
    //     formItems.push(formItem);
    //   }

      //this.setState({ formItems: formItems });
    }
    return (
      <Modal
        width={600}
        title="Insert Record"
        mask={true}
        visible={visible}
        onOk={this.handleOk}
        confirmLoading={confirmLoading}
        onCancel={this.handleCancel}
        layout="horizontal"
        cancelText="Return"
        okText="Save"
      >
        <Form>{formItems}</Form>
      </Modal>
    );
  }
}

export default Form.create({ name: "edit-table-row-form" })(InsertTableRow);
